/**
 * Copyright (c) 2021-2024 Kognitos, Inc. All rights reserved.
 */

const blue = {
  blue1: '#f0f5ff',
  blue2: '#d6e4ff',
  blue3: '#adc6ff',
  blue4: '#85a5ff',
  blue5: '#597ef7',
  blue6: '#2f54eb',
  blue7: '#1d39c4',
  blue8: '#10239e',
  blue9: '#061178',
  blue10: '#030852'
};

const green = {
  green1: '#f6ffed',
  green2: '#d9f7be',
  green3: '#b7eb8f',
  green4: '#95de64',
  green5: '#73d13d',
  green6: '#52c41a',
  green7: '#389e0d',
  green8: '#237804',
  green9: '#135200',
  green10: '#092b00'
};

const red = {
  red1: '#fff1f0',
  red2: '#ffccc7',
  red3: '#ffa39e',
  red4: '#ff7875',
  red5: '#ff4d4f',
  red6: '#f5222d',
  red7: '#cf1322',
  red8: '#a8071a',
  red9: '#820014',
  red10: '#5c0011'
};

const gold = {
  gold1: '#fffbe6',
  gold2: '#fff1b8',
  gold3: '#ffe58f',
  gold4: '#ffd666',
  gold5: '#ffc53d',
  gold6: '#faad14',
  gold7: '#d48806',
  gold8: '#ad6800',
  gold9: '#874d00',
  gold10: '#613400'
};

const volcano = {
  volcano1: '#fff2e8',
  volcano2: '#ffd8bf',
  volcano3: '#ffbb96',
  volcano4: '#ff9c6e',
  volcano5: '#ff7a45',
  volcano6: '#fa541c',
  volcano7: '#d4380d',
  volcano8: '#ad2102',
  volcano9: '#871400',
  volcano10: '#610b00'
};

const purple = {
  purple1: '#f9f0ff',
  purple2: '#efdbff',
  purple3: '#d3adf7',
  purple4: '#b37feb',
  purple5: '#9254de',
  purple6: '#722ed1',
  purple7: '#531dab',
  purple8: '#391085',
  purple9: '#22075e',
  purple10: '#120338'
};

const gray = {
  neutral1: '#ffffff',
  neutral2: '#F5F5FA',
  neutral3: '#D7D7E3',
  neutral4: '#C2C2D0',
  neutral5: '#AEAEBF',
  neutral6: '#9292A6',
  neutral7: '#818199',
  neutral8: '#666680',
  neutral9: '#4A4A61',
  neutral10: '#3B3B52',
  neutral11: '#303048',
  neutral12: '#1C1C2E',
  neutral13: '#000000'
};

const brandColors = {
  colorPrimary: purple.purple6,
  colorLink: purple.purple6
};

const semanticColors = {
  // Backgrounds
  bodyBg: gray.neutral2,
  colorBaseBg: gray.neutral1,

  // Text
  colorText: gray.neutral10,
  colorTextBase: gray.neutral13,

  // Border
  defaultBorderColor: gray.neutral3,

  // Success
  colorSuccess: green.green6,
  // Info
  colorInfo: blue.blue6,
  colorInfoBg: blue.blue1,
  colorInfoBorder: blue.blue5,
  // error
  colorError: red.red6,
  // warning
  colorWarning: gold.gold6
};

export default {
  ...gray,
  ...blue,
  ...green,
  ...red,
  ...volcano,
  ...gold,
  ...purple,
  ...brandColors,
  ...semanticColors
};
